require("core-js/modules/esnext.global-this.js");
(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports, require('js-cookie'), require('sniffr')) : typeof define === 'function' && define.amd ? define(['exports', 'js-cookie', 'sniffr'], factory) : (global = typeof globalThis !== 'undefined' ? globalThis : global || self, factory(global.FLTracking = {}, global.Cookies, global.Sniffr));
})(this, function (exports, Cookies, Sniffr) {
  'use strict';

  function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      enumerableOnly && (symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      })), keys.push.apply(keys, symbols);
    }
    return keys;
  }
  function _objectSpread2(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = null != arguments[i] ? arguments[i] : {};
      i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
    return target;
  }
  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }
    return obj;
  }
  function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for (i = 0; i < sourceKeys.length; i++) {
      key = sourceKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      target[key] = source[key];
    }
    return target;
  }
  function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
      var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
      for (i = 0; i < sourceSymbolKeys.length; i++) {
        key = sourceSymbolKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
        target[key] = source[key];
      }
    }
    return target;
  }
  function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
  }
  function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
  }
  function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
      for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);
        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"] != null) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }
    return _arr;
  }
  function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
  }
  function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
    return arr2;
  }
  function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  /**
   * Returns a random v4 UUID of the form xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx,
   * where each x is replaced with a random hexadecimal digit from 0 to f, and
   * y is replaced with a random hexadecimal digit from 8 to b.
   *
   * DO WHAT THE FUCK YOU WANT TO PUBLIC LICENSE
   *           Version 2, December 2004
   *
   * Copyright (C) 2011 Jed Schmidt <http://jed.is>
   *
   * Everyone is permitted to copy and distribute verbatim or modified
   * copies of this license document, and changing it is allowed as long
   * as the name is changed.
   *
   *            DO WHAT THE FUCK YOU WANT TO PUBLIC LICENSE
   *   TERMS AND CONDITIONS FOR COPYING, DISTRIBUTION AND MODIFICATION
   *
   *  0. You just DO WHAT THE FUCK YOU WANT TO.
   *
   * @note Code from https://gist.github.com/jed/982883
   */
  /* eslint-disable */
  function uuid(a) {
    return a // if the placeholder was passed, return
    ?
    // a random number from 0 to 15
    (a ^
    // unless b is 8,
    Math.random() *
    // in which case
    16 >>
    // a random number from
    a / 4
    // 8 to 11
    ).toString(16) // in hexadecimal
    :
    // or otherwise a concatenated string:
    ([1e7] +
    // 10000000 +
    -1e3 +
    // -1000 +
    -4e3 +
    // -4000 +
    -8e3 +
    // -80000000 +
    -1e11
    // -100000000000,
    ).replace(
    // replacing
    /[018]/g,
    // zeroes, ones, and eights with
    uuid // random hex digits
    );
  }
  /* eslint-enable */

  function decode(value) {
    if (typeof value === 'undefined') {
      return null;
    }
    return decodeURIComponent(value.replace(/\+/g, ' '));
  }

  /**
   * Parse query string and map it to object's keys and values
   * Silently ignore that query string can contain multiple values for the same key
   * (i.e. '?a=1&a=2')
   *
   * @param {string} queryString search part of url
   * @return {object}
   */
  function urlParameters(queryString) {
    if (typeof queryString === 'undefined' || queryString.length === 0) {
      return {};
    }
    return queryString.split('&').reduce(function (result, pair) {
      var _pair$split = pair.split('='),
        _pair$split2 = _slicedToArray(_pair$split, 2),
        key = _pair$split2[0],
        value = _pair$split2[1];
      var decodedKey = decode(key);
      var decodedValue = decode(value);
      return _objectSpread2(_objectSpread2({}, result), {}, _defineProperty({}, decodedKey, decodedValue));
    }, {});
  }

  /**
   * Fetch CID from URL parameter or generate one from `referrer`'
   */
  function getCampaignId(parameters) {
    var referrer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    var cid = parameters.CID || parameters.cid;
    var ref = parameters.referrer || referrer;
    if (!cid) {
      if (ref === '') {
        return '_DTI_0_1';
      }
      if (ref.match(/^https:\/\/www\.google\./)) {
        return '_SEO_0_1';
      }
      return '_FRF_0_0';
    }
    return cid;
  }

  /**
   * Fetch CID from URL parameter or generate one from `referrer`'
   * @todo move it to base package probably
   */
  var freeleticsUrlRegexp = /^https?:\/\/(?:(?:[A-Za-z0-9.-]+\.)?freeletics\.(?:com|de|fr)|(?:www\.)?frltcs\.com)(?:[/?#]|$)/;
  var FREELETICS_URL_REGEXP = freeleticsUrlRegexp;

  /**
   * Create a cookie with given a `name` and `value` lasting 1 year on `domain`.
   */
  function setCookie(domain, name, value) {
    var options = {
      domain: domain,
      expires: 365,
      path: '/'
    };
    if (typeof value === 'undefined') {
      Cookies.remove(name, options);
    } else {
      Cookies.set(name, value, options);
    }
  }
  var uuidValue;
  /**
   * Fetch UUID. If none exist then one is created.
   * Store UUID in cookies if consent given, if not, remove cookie from browser
   */
  function getUUID() {
    var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    if (!uuidValue) {
      uuidValue = Cookies.get(config.CID_KEY);
      if (!uuidValue) {
        uuidValue = uuid();
      }
    }
    setCookie(config.COOKIES_DOMAIN, config.CID_KEY, uuidValue);
    return uuidValue;
  }
  function refreshTokenRequest(config) {
    var userId = Cookies.get(config.AUTH_USER_ID);
    var refreshToken = Cookies.get(config.AUTH_REFRESH_TOKEN);
    var xhr = new XMLHttpRequest();
    return new Promise(function (resolve, reject) {
      xhr.onload = function () {
        if (xhr.status >= 200 && xhr.status < 300) {
          var idToken = JSON.parse(xhr.response).auth.id_token;
          Cookies.set(config.AUTH_ID_TOKEN, idToken);
          resolve(idToken);
        } else {
          reject();
        }
      };
      xhr.onerror = function () {
        reject();
      };
      xhr.open('POST', "".concat(config.USER_API_URL, "/v1/auth/refresh"), true);
      xhr.setRequestHeader('Content-Type', 'application/json');
      xhr.send(JSON.stringify({
        user_id: userId,
        refresh_token: refreshToken
      }));
    });
  }

  /**
   * Create default XMLHttpRequest object
   */
  function createXMLHttpRequest(_ref) {
    var method = _ref.method,
      url = _ref.url,
      authIdToken = _ref.authIdToken,
      config = _ref.config,
      data = _ref.data;
    var token = authIdToken || Cookies.get(config.AUTH_ID_TOKEN);
    var xhr = new XMLHttpRequest();
    return new Promise(function (resolve) {
      xhr.onload = function () {
        if (xhr.status >= 200 && xhr.status < 300) {
          resolve(xhr.response);
        } else if (xhr.status === 419) {
          refreshTokenRequest(config).then(function (idToken) {
            return createXMLHttpRequest({
              method: method,
              url: url,
              authIdToken: idToken,
              config: config,
              data: data
            }).then(resolve);
          })["catch"](resolve);
        } else {
          // swallow error
          resolve();
        }
      };
      xhr.onerror = function () {
        // swallow error
        resolve();
      };
      xhr.open(method, url, true);
      xhr.setRequestHeader('Content-Type', 'application/json');
      if (token) {
        xhr.setRequestHeader('Authorization', "Bearer ".concat(token));
      }
      xhr.send(JSON.stringify(data));
    });
  }

  /**
   * Track CID Event.
   */
  function trackCIDEvent(config, _ref2) {
    var cid = _ref2.cid,
      referrer = _ref2.referrer,
      target = _ref2.target;
    var parameters = urlParameters(window.location.search.substr(1));
    var url = "".concat(config.API_URL, "/v2/analytics/cid_events");
    var data = {
      cid_event: {
        cid: cid || getCampaignId(parameters, document.referrer),
        ref: referrer || parameters.referrer || document.referrer,
        target: target || document.location.href,
        user_uuid: getUUID(config)
      }
    };

    // Do not track our own referrals
    if (!(cid || parameters.CID || parameters.cid) && document.referrer.match(FREELETICS_URL_REGEXP)) {
      return Promise.resolve();
    }
    return createXMLHttpRequest({
      method: 'POST',
      url: url,
      config: config,
      data: data
    });
  }

  /**
   * Track assignement of CID Event.
   */
  function trackCIDEventAssign(config, userUUID, authIdToken) {
    var url = "".concat(config.API_URL, "/v2/analytics/cid_events/assign");
    var data = {
      user_uuid: userUUID || getUUID(config)
    };
    return createXMLHttpRequest({
      method: 'PATCH',
      url: url,
      authIdToken: authIdToken,
      config: config,
      data: data
    });
  }

  /**
   * Get CID from URL if exists otherwise create it
   * Store the CID into a cookies with `domain=freeletics.com`
   * Notify backend using API `/v2/analytics/cid_events/`
   */
  var DEFAULTS = Object.freeze({
    API_URL: 'http://localhost:3000',
    USER_API_URL: 'http://localhost:3001',
    AUTH_USER_ID: 'auth_user_id',
    AUTH_ID_TOKEN: 'auth_id_token',
    AUTH_REFRESH_TOKEN: 'auth_refresh_token',
    CID_KEY: 'CID_UUID',
    COOKIES_DOMAIN: null
  });
  var cid = {
    config: _objectSpread2({}, DEFAULTS),
    /**
     * Configure CID Tracking
     *
     * @param {Object} options
     * @param {string} options.API_URL - URL for the CID Tracking API
     * @param {string} options.CID_KEY - Name of CID Key
     */
    configure: function configure(options) {
      this.config = _objectSpread2(_objectSpread2({}, this.config), options);
    },
    /**
     * Track CID events.
     *
     * A CID event should be fired whenever a user land on a page.
     * It can also be called when CID event is triggered from inside application,
     * with tracked id passed in parameter
     *
     * @example
     * // Track a CID event when landing on a page
     * tracker.track();
     *
     * // Track a CID event programatically
     * tracker.track({ cid: 'CampaignID' });
     * tracker.track({
     *   cid: 'CampaignId',
     *   referrer: 'http://freeletics.com',
     *   target: window.location.href,
     * })
     *
     * @param parameters[Object<String,String>]
     * @param parameters.cid[String] - optional campaign id
     * @param parameters.referrer[String] - optional referrer value
     * @param parameters.target[String] - optional target value
     */
    track: function track() {
      var parameters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return trackCIDEvent(this.config, parameters);
    },
    /**
     * Track CID login event.
     *
     * A CID event should be fired when user logs in on a page (automatically or intentionally).
     * This sends assign event to backend, for all anonymous events to be assigned with current
     * user
     *
     * @example
     * tracker.trackLogin();
     */
    trackLogin: function trackLogin() {
      return trackCIDEventAssign(this.config);
    },
    /**
     * Assign given UUID to logged in user
     */
    assignUUID: function assignUUID(uuid, authIdToken) {
      return trackCIDEventAssign(this.config, uuid, authIdToken);
    },
    /**
     * Get the Unique User ID (UUID).
     */
    getUUID: function getUUID$1() {
      return getUUID(this.config);
    }
  };
  var _excluded = ["pathname", "search", "referrer"];
  var sniffr;
  // basically try to revert "magic" done by sniffr package:
  // - when file is used in module context, sniffr exports itself
  // - when file is used in browser context (i.e. no webpack build), sniffr attaches to window
  if (typeof module !== 'undefined' && module.exports) {
    sniffr = new Sniffr();
    sniffr.sniff(
    // Use fake user agent when running on the server to prevent Sniffr from
    // trying to access navigator object.
    typeof navigator === 'undefined' ? 'fake-user-agent' : navigator.userAgent);
  } else {
    sniffr = window.Sniffr;
  }
  var VERSION = '2018.03.20';

  // Format date to ISO 8601 standard with timezone
  function getISOTime() {
    var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Date();
    var year = date.getFullYear();
    var month = date.getMonth() + 1;
    var day = date.getDay();
    var hours = date.getHours();
    var minutes = date.getMinutes();
    var seconds = date.getSeconds();
    var timezone = date.getTimezoneOffset();
    function pad(number) {
      if (number < 10) {
        return "0".concat(number);
      }
      return number;
    }
    var datePart = [year, pad(month), pad(day)].join('-');
    var timePart = [pad(hours), pad(minutes), pad(seconds)].join(':');
    var timezonePart = [timezone < 0 ? '-' : '+', pad(parseInt(Math.abs(timezone) / 60, 10)), pad(Math.abs(timezone) % 60)].join('');
    return "".concat(datePart, "T").concat(timePart).concat(timezonePart);
  }
  function asString(value) {
    var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    if (typeof value !== 'undefined') {
      return "".concat(value);
    }
    return defaultValue;
  }
  function getGeneralBaseProperties() {
    return {
      // General Base Properties
      platform_type: 'web',
      trigger_type: 'direct',
      fl_user_id: asString(Cookies.get('auth_user_id'), '-1'),
      session_id: asString(Cookies.get('CID_UUID')),
      version_id: asString(VERSION),
      local_fired_at: asString(getISOTime())
    };
  }
  function getWebSpecificBaseProperties() {
    return {
      // Web Specific Base Properties
      browser_type: asString(sniffr.browser.name),
      browser_version_id: asString(sniffr.browser.versionString),
      country_code: asString(Cookies.get('country_code')),
      os_type: asString(sniffr.os.name)
    };
  }
  var lastPageviewUrl;
  var analyticsTracker = {
    track: function track(event, data) {
      window.dataLayer = window.dataLayer || [];
      var eventProperties = _objectSpread2(_objectSpread2(_objectSpread2({
        event: event
      }, getGeneralBaseProperties()), getWebSpecificBaseProperties()), data);
      window.dataLayer.push(eventProperties);
    },
    trackPageImpression: function trackPageImpression() {
      var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var _ref2$pathname = _ref2.pathname,
        pathname = _ref2$pathname === void 0 ? window.location.pathname : _ref2$pathname,
        _ref2$search = _ref2.search,
        search = _ref2$search === void 0 ? window.location.search : _ref2$search,
        _ref2$referrer = _ref2.referrer,
        referrer = _ref2$referrer === void 0 ? document.referrer : _ref2$referrer,
        rest = _objectWithoutProperties(_ref2, _excluded);
      var query = search ? search.substring(1) : '';
      var url = "".concat(pathname, "?").concat(query);

      // simple throttle version based on url, do not send pageview for the same url multiple times
      // this allows to track landing page event and route change events in Single Page Application
      if (lastPageviewUrl === url) {
        return;
      }

      // extract data from query parameters
      var parameters = urlParameters(query);
      var ref = parameters.referrer || referrer;

      // set default values for special page_impression parameters
      var isLandingPage = false;
      var CID = '';

      // only if we're not referenced by Freeletics page and it's first pageview in this instance
      // set parameters for first page impression event
      // this allows us to use this code in multiple applications, and only track user's first visit
      // as landing page, i.e.:
      // 1. user visits wordpress blog - isLandingPage === "true"
      // 2. user reads few articles and clicks link to angular application
      // 3. user lands on bodyweight/coach/get in angular application - this is first pageload of
      //    angular application, but it should not be counted as first pageview in freeletics
      //    universere, we distinguish it by checkint document.referrer
      if (typeof lastPageviewUrl === 'undefined' && !referrer.match(freeleticsUrlRegexp)) {
        isLandingPage = true;
        CID = getCampaignId(parameters, ref);
      }

      // don't forget to set current url as last tracked
      lastPageviewUrl = url;
      this.track('page_impression', _objectSpread2({
        url_path: pathname,
        url_query: query,
        is_landing_page: isLandingPage,
        referrer_url: isLandingPage ? ref : '',
        CID: isLandingPage ? CID : ''
      }, rest));
    },
    getCampaignId: getCampaignId
  };

  // little hack, allows us to reset state in tests
  analyticsTracker.trackPageImpression.reset = function () {
    lastPageviewUrl = undefined;
  };
  function GATracker(_ref) {
    var locale = _ref.locale;
    // https://docs.google.com/spreadsheets/d/1-3rzvR219Er1SoPC_xF3CU-As2p9sg9YlOfw7ZjEVoI/edit#gid=1636264427
    var pageTypeMatchers = {
      shop: function shop(_ref2) {
        var hostname = _ref2.hostname;
        return /shop\.freeletics\.(com|de|fr)$/.test(hostname);
      },
      homepage: function homepage(_ref3) {
        var pathname = _ref3.pathname;
        return /^\/[a-z]{2}\/?$/.test(pathname);
      },
      training: function training(_ref4) {
        var pathname = _ref4.pathname;
        return /^\/[a-z]{2}\/training\/?$/.test(pathname);
      },
      calculator: function calculator(_ref5) {
        var pathname = _ref5.pathname;
        return /^\/[a-z]{2}\/calculator\/?$/.test(pathname);
      },
      partnership: function partnership(_ref6) {
        var pathname = _ref6.pathname;
        return /^\/[a-z]{2}\/partnership\/?$/.test(pathname);
      },
      ambassadors: function ambassadors(_ref7) {
        var pathname = _ref7.pathname;
        return /^\/[a-z]{2}\/ambassadors\/?$/.test(pathname);
      },
      trainAtHome: function trainAtHome(_ref8) {
        var pathname = _ref8.pathname;
        return /^\/[a-z]{2}\/trainAtHome\/?$/.test(pathname);
      },
      mobileLandingPage: function mobileLandingPage(_ref9) {
        var pathname = _ref9.pathname;
        return /^\/[a-z]{2}\/mobileLandingPage\/?$/.test(pathname);
      },
      press: function press(_ref10) {
        var pathname = _ref10.pathname;
        return /^\/[a-z]{2}\/press\/?$/.test(pathname);
      },
      nutrition: function nutrition(_ref11) {
        var pathname = _ref11.pathname;
        return /^\/[a-z]{2}\/nutrition\/?$/.test(pathname);
      },
      blog: function blog(_ref12) {
        var pathname = _ref12.pathname;
        return /^\/[a-z]{2}\/blog(\/|$)/.test(pathname);
      },
      buying: function buying(_ref13) {
        var pathname = _ref13.pathname;
        return /^\/[a-z]{2}\/bodyweight\/coach\/get(\/|$)/.test(pathname);
      },
      targeting: function targeting(_ref14) {
        var pathname = _ref14.pathname;
        return /^\/[a-z]{2}\/targeting(\/|$)/.test(pathname);
      },
      onboard: function onboard(_ref15) {
        var pathname = _ref15.pathname;
        return /^\/[a-z]{2}\/athlete-assessment(\/|$)/.test(pathname);
      },
      'checkout-portfolio': function checkoutPortfolio(_ref16) {
        var pathname = _ref16.pathname,
          search = _ref16.search;
        return /^\/[a-z]{2}\/checkout\/[a-z-]+\/?$/.test(pathname) && !/(\?|&)step=\d/.test(search);
      },
      'checkout-pay': function checkoutPay(_ref17) {
        var pathname = _ref17.pathname,
          search = _ref17.search;
        return /^\/[a-z]{2}\/checkout\/[a-z-]+\/?$/.test(pathname) && /(\?|&)step=2/.test(search);
      },
      'checkout-confirm': function checkoutConfirm(_ref18) {
        var pathname = _ref18.pathname;
        return /^\/[a-z]{2}\/checkout\/congratulations\/[a-z-]+\/?$/.test(pathname);
      },
      register: function register(_ref19) {
        var pathname = _ref19.pathname;
        return /^\/[a-z]{2}\/auth\/registration(\/|$)/.test(pathname);
      },
      login: function login(_ref20) {
        var pathname = _ref20.pathname;
        return /^\/[a-z]{2}\/auth\/login(\/|$)/.test(pathname);
      },
      settings: function settings(_ref21) {
        var pathname = _ref21.pathname;
        return /^\/[a-z]{2}\/settings(\/|$)/.test(pathname);
      }
    };
    function pageType() {
      var types = Object.keys(pageTypeMatchers);
      for (var i = 0; i < types.length; i += 1) {
        var matcher = pageTypeMatchers[types[i]];
        if (matcher(window.location)) {
          return types[i];
        }
      }
      return 'other';
    }

    // https://docs.google.com/spreadsheets/d/1-3rzvR219Er1SoPC_xF3CU-As2p9sg9YlOfw7ZjEVoI/edit#gid=1453285200
    function generalData() {
      var countryCode = Cookies.get('country_code');
      var userId = Cookies.get('auth_user_id');
      return {
        event: 'analytics_event',
        interaction_code: null,
        content_language: locale,
        country_code: countryCode,
        campaign_id: '',
        user_loggedin: userId ? 'y' : 'n',
        hit_type: 'event',
        url_path: window.location.pathname,
        page_type: pageType(),
        server_status: '200',
        fl_user_id: userId || '-1'
      };
    }

    // Google Tag Manager
    function gtm(attr) {
      if (window.dataLayer != null) {
        window.dataLayer.push(attr);
      }
    }
    function track() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      gtm(_objectSpread2(_objectSpread2({}, generalData()), data));
    }
    return {
      track: track
    };
  }
  exports.GATracker = GATracker;
  exports.analytics = analyticsTracker;
  exports.cid = cid;
});